import { DEFAULT_FIRST_NAME_FIELD, DEFAULT_LAST_NAME_FIELD, DEFAULT_LINE_1_FIELD, DEFAULT_LINE_2_FIELD, DEFAULT_COUNTRY_FIELD, DEFAULT_CITY_FIELD, DEFAULT_ZIP_CODE_FIELD, DEFAULT_PHONE_FIELD, DEFAULT_STATE_FIELD, DEFAULT_PROVINCE_FIELD, DEFAULT_STATE_PROVINCE_REGION_FIELD, DEFAULT_POSTAL_CODE_FIELD, DEFAULT_INTL_PHONE_FIELD, } from './fields';
const AE_REQUIREMENTS = [
    DEFAULT_FIRST_NAME_FIELD,
    DEFAULT_LAST_NAME_FIELD,
    { ...DEFAULT_LINE_1_FIELD, label: 'Street Name' },
    {
        ...DEFAULT_LINE_2_FIELD,
        label: 'Building name/no., floor, apt., villa no., or Aramax Account',
    },
    { ...DEFAULT_CITY_FIELD, label: 'Emirate/City' },
    { ...DEFAULT_STATE_FIELD, label: 'Area/District' },
    DEFAULT_COUNTRY_FIELD,
    {
        ...DEFAULT_PHONE_FIELD,
        pattern: /^\+971(\d*)$/,
        example: '+97112345678',
    },
];
const EU_REQUIREMENTS = [
    DEFAULT_FIRST_NAME_FIELD,
    DEFAULT_LAST_NAME_FIELD,
    { ...DEFAULT_LINE_1_FIELD, maxLength: 40 },
    { ...DEFAULT_LINE_2_FIELD, maxLength: 40 },
    DEFAULT_COUNTRY_FIELD,
    DEFAULT_CITY_FIELD,
    { ...DEFAULT_STATE_PROVINCE_REGION_FIELD, maxLength: 40 },
    DEFAULT_POSTAL_CODE_FIELD,
    DEFAULT_INTL_PHONE_FIELD,
];
const UK_REQUIREMENTS = [
    DEFAULT_FIRST_NAME_FIELD,
    DEFAULT_LAST_NAME_FIELD,
    { ...DEFAULT_LINE_1_FIELD, maxLength: 30 },
    { ...DEFAULT_LINE_2_FIELD, maxLength: 30 },
    DEFAULT_COUNTRY_FIELD,
    DEFAULT_CITY_FIELD,
    { ...DEFAULT_STATE_PROVINCE_REGION_FIELD, maxLength: 30 },
    DEFAULT_POSTAL_CODE_FIELD,
    { ...DEFAULT_INTL_PHONE_FIELD, example: '+447911123456' },
];
const SA_IDENTIFICATION_NUMBER = {
    type: 'identification_number',
    label: 'Saudi Arabia ID Number',
    required: true,
    minLength: 10,
    maxLength: 10,
    pattern: /^[0-9]*$/,
};
const BH_KW_REQUIREMENTS = [
    DEFAULT_FIRST_NAME_FIELD,
    DEFAULT_LAST_NAME_FIELD,
    DEFAULT_LINE_1_FIELD,
    {
        ...DEFAULT_LINE_2_FIELD,
        label: 'Building Name, Apt, Suite, etc. (Optional)',
    },
    DEFAULT_COUNTRY_FIELD,
    DEFAULT_CITY_FIELD,
    { ...DEFAULT_STATE_FIELD, label: 'Area Name', required: false },
    DEFAULT_POSTAL_CODE_FIELD,
];
const BH_REQUIREMENTS = [
    ...BH_KW_REQUIREMENTS,
    { ...DEFAULT_PHONE_FIELD, example: '+97312345678' },
];
const KW_REQUIREMENTS = [
    ...BH_KW_REQUIREMENTS,
    { ...DEFAULT_PHONE_FIELD, example: '+96512345678' },
];
/* eslint-disable id-length */
/**
 * Provides shipping address requirements for each country.
 * This drives address entry forms and validations.
 * Any new labels must be added to the addressForm.json file to get translated to other languages
 */
export const ADDRESS_REQUIREMENTS_BY_COUNTRY = {
    AE: AE_REQUIREMENTS,
    AT: EU_REQUIREMENTS,
    AU: [
        DEFAULT_FIRST_NAME_FIELD,
        DEFAULT_LAST_NAME_FIELD,
        DEFAULT_LINE_1_FIELD,
        DEFAULT_LINE_2_FIELD,
        DEFAULT_COUNTRY_FIELD,
        DEFAULT_STATE_FIELD,
        DEFAULT_ZIP_CODE_FIELD,
        DEFAULT_CITY_FIELD,
        { ...DEFAULT_INTL_PHONE_FIELD, example: '+61123456789' },
    ],
    AX: EU_REQUIREMENTS,
    BE: EU_REQUIREMENTS,
    BG: EU_REQUIREMENTS,
    BH: BH_REQUIREMENTS,
    CA: [
        DEFAULT_FIRST_NAME_FIELD,
        DEFAULT_LAST_NAME_FIELD,
        DEFAULT_LINE_1_FIELD,
        DEFAULT_LINE_2_FIELD,
        DEFAULT_COUNTRY_FIELD,
        DEFAULT_CITY_FIELD,
        DEFAULT_PROVINCE_FIELD,
        DEFAULT_ZIP_CODE_FIELD,
        DEFAULT_PHONE_FIELD,
    ],
    CH: EU_REQUIREMENTS,
    CY: EU_REQUIREMENTS,
    CZ: EU_REQUIREMENTS,
    DE: EU_REQUIREMENTS,
    DK: EU_REQUIREMENTS,
    EE: EU_REQUIREMENTS,
    ES: EU_REQUIREMENTS,
    FI: EU_REQUIREMENTS,
    FO: EU_REQUIREMENTS,
    FR: EU_REQUIREMENTS,
    GB: UK_REQUIREMENTS,
    GG: UK_REQUIREMENTS,
    GL: EU_REQUIREMENTS,
    GR: EU_REQUIREMENTS,
    HR: EU_REQUIREMENTS,
    HU: EU_REQUIREMENTS,
    IE: EU_REQUIREMENTS,
    IT: EU_REQUIREMENTS,
    IS: EU_REQUIREMENTS,
    JE: UK_REQUIREMENTS,
    JP: [
        DEFAULT_FIRST_NAME_FIELD,
        DEFAULT_LAST_NAME_FIELD,
        DEFAULT_LINE_1_FIELD,
        DEFAULT_LINE_2_FIELD,
        DEFAULT_COUNTRY_FIELD,
        DEFAULT_CITY_FIELD,
        { ...DEFAULT_STATE_FIELD, label: 'Prefecture' },
        DEFAULT_POSTAL_CODE_FIELD,
        { ...DEFAULT_PHONE_FIELD, example: '+8100012345678' },
    ],
    KW: KW_REQUIREMENTS,
    LT: EU_REQUIREMENTS,
    LU: EU_REQUIREMENTS,
    LV: EU_REQUIREMENTS,
    MC: EU_REQUIREMENTS,
    MT: EU_REQUIREMENTS,
    NL: EU_REQUIREMENTS,
    NO: EU_REQUIREMENTS,
    NZ: [
        DEFAULT_FIRST_NAME_FIELD,
        DEFAULT_LAST_NAME_FIELD,
        DEFAULT_LINE_1_FIELD,
        DEFAULT_LINE_2_FIELD,
        DEFAULT_COUNTRY_FIELD,
        DEFAULT_CITY_FIELD,
        DEFAULT_PROVINCE_FIELD,
        DEFAULT_ZIP_CODE_FIELD,
        { ...DEFAULT_INTL_PHONE_FIELD, example: '+64123456789' },
    ],
    PL: EU_REQUIREMENTS,
    PT: EU_REQUIREMENTS,
    QA: [
        DEFAULT_FIRST_NAME_FIELD,
        DEFAULT_LAST_NAME_FIELD,
        { ...DEFAULT_LINE_1_FIELD, label: 'Street Name' },
        DEFAULT_LINE_2_FIELD,
        DEFAULT_COUNTRY_FIELD,
        DEFAULT_CITY_FIELD,
        {
            ...DEFAULT_PHONE_FIELD,
            pattern: /^\+974(\d*)$/,
            example: '+97412345678',
        },
    ],
    RO: EU_REQUIREMENTS,
    SA: [
        DEFAULT_FIRST_NAME_FIELD,
        DEFAULT_LAST_NAME_FIELD,
        { ...DEFAULT_LINE_1_FIELD, label: 'Street Name and Number' },
        { ...DEFAULT_LINE_2_FIELD, label: 'Neighborhood or District (Optional)' },
        DEFAULT_COUNTRY_FIELD,
        DEFAULT_CITY_FIELD,
        DEFAULT_POSTAL_CODE_FIELD,
        {
            ...DEFAULT_PHONE_FIELD,
            pattern: /^\+966(\d*)$/,
            example: '+96612345678',
        },
        SA_IDENTIFICATION_NUMBER,
    ],
    SE: EU_REQUIREMENTS,
    SG: [
        DEFAULT_FIRST_NAME_FIELD,
        DEFAULT_LAST_NAME_FIELD,
        DEFAULT_LINE_1_FIELD,
        DEFAULT_LINE_2_FIELD,
        DEFAULT_COUNTRY_FIELD,
        DEFAULT_CITY_FIELD,
        DEFAULT_POSTAL_CODE_FIELD,
        { ...DEFAULT_PHONE_FIELD, example: '+6512345678' },
    ],
    SK: EU_REQUIREMENTS,
    SI: EU_REQUIREMENTS,
    US: [
        DEFAULT_FIRST_NAME_FIELD,
        DEFAULT_LAST_NAME_FIELD,
        DEFAULT_LINE_1_FIELD,
        DEFAULT_LINE_2_FIELD,
        DEFAULT_COUNTRY_FIELD,
        DEFAULT_CITY_FIELD,
        DEFAULT_STATE_FIELD,
        DEFAULT_ZIP_CODE_FIELD,
        DEFAULT_PHONE_FIELD,
    ],
    ZA: [
        DEFAULT_FIRST_NAME_FIELD,
        DEFAULT_LAST_NAME_FIELD,
        DEFAULT_LINE_1_FIELD,
        DEFAULT_LINE_2_FIELD,
        DEFAULT_COUNTRY_FIELD,
        DEFAULT_CITY_FIELD,
        DEFAULT_PROVINCE_FIELD,
        DEFAULT_POSTAL_CODE_FIELD,
        { ...DEFAULT_PHONE_FIELD, example: '+270001234567' },
    ],
};
/* eslint-enable id-length */
